// Given some input keys similar to this:
//   customer[11270233][RECEIPT]
//   customer[11270233][amount]
//   customer[11270233][csc]
//   customer[11270233][inv]
//   customer[11270233][tranx]
//   customer[11270234][RECEIPT]
//   customer[11270234][amount]
//   customer[11270234][csc]
//   customer[11270234][inv]
//   customer[11270234][tranx]
// When pulled from a form, we want to translate them to a data structure
// that can be more easily iterated on:
// {
//   11270233: {
//     RECEIPT: "",
//     amount: "",
//     ...
//   },
//   11270234: {
//     RECEIPT: "",
//     amount: "",
//     ...
//   },
// }
export function formKeysToObjects (formKeys: {[ key: string ]: string }) {
  const objects = {}

  Object.keys(formKeys).forEach(formKey => {
    const parsed = formKey.match(/.*?\[(.*?)\]\[(.*?)\]/)

    if (!parsed) {
      return
    }

    const [_, entity, entityKey] = parsed

    if (!objects[entity]) {
      objects[entity] = {}
    }

    objects[entity][entityKey] = formKeys[formKey]
  })

  return objects
}
